module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row nav-top-row"
  }, [_c('div', {
    class: {
      'active': _vm.panelOpen
    },
    attrs: {
      "id": "nav-burger"
    },
    on: {
      "click": _vm.clickBurger
    }
  }, [_c('div', {
    staticClass: "burger-bar burger-bar-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "burger-bar burger-bar-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "burger-bar burger-bar-3"
  })]), _vm._v(" "), _c('div', {
    staticClass: "top-bar"
  }, [_c('div', {
    staticClass: "nav-logo"
  }, [(_vm.pagename !== 'home') ? _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "nav-logo-png",
    attrs: {
      "src": 'static/img/common/logo.png'
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.pagename == 'home') ? _c('div', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#top'),
      expression: "'#top'"
    }]
  }, [_c('img', {
    staticClass: "nav-logo-png nav-logo-home",
    class: {
      'active': _vm.hideMainMenu
    },
    attrs: {
      "src": 'static/img/common/logo.png'
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_c('span', {
    class: {
      'active': _vm.pagename === 'about'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.nav.about)
    }
  })])], 1), _vm._v(" "), _c('li', {
    staticClass: "top-bar-dropdown-container",
    on: {
      "mouseover": function($event) {
        _vm.showDropdown = true
      },
      "mouseout": function($event) {
        _vm.showDropdown = false
      }
    }
  }, [_c('div', {
    staticClass: "top-bar-dropdown-button"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.nav.whatwedo)
    }
  })]), _vm._v(" "), (_vm.showDropdown) ? _c('div', {
    staticClass: "top-bar-dropdown-links"
  }, [_c('div', {
    staticClass: "top-bar-dropdown-link"
  }, [_c('router-link', {
    attrs: {
      "to": "/food"
    }
  }, [_c('span', {
    class: {
      'active': _vm.pagename === 'food'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.nav.food)
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "top-bar-dropdown-link"
  }, [_c('router-link', {
    attrs: {
      "to": "/projects"
    }
  }, [_c('span', {
    class: {
      'active': _vm.pagename === 'projects'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.nav.projects)
    }
  })])], 1)]) : _vm._e()]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/takeaway"
    }
  }, [_c('span', {
    class: {
      'active': _vm.pagename === 'takeaway'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.nav.takeaway)
    }
  })])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#gallery-container'),
      expression: "'#gallery-container'"
    }]
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.nav.gallery)
    }
  })]), _vm._v(" "), _c('li', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#contact-section'),
      expression: "'#contact-section'"
    }]
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.nav.contact)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "nav-panel",
    class: {
      'active': _vm.panelOpen
    }
  }, [_c('div', {
    staticClass: "nav-panel-inner",
    class: {
      'active': _vm.panelOpen
    }
  }, [_c('ul', [(_vm.pagename === 'home') ? _c('li', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#top'),
      expression: "'#top'"
    }]
  }, [_c('span', {
    class: {
      'active': _vm.pagename === 'home'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.nav.home)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.pagename !== 'home') ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('span', {
    class: {
      'active': _vm.pagename === 'home'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.nav.home)
    }
  })])], 1) : _vm._e(), _c('br'), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_c('span', {
    class: {
      'active': _vm.pagename === 'about'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.nav.about)
    }
  })])], 1), _c('br'), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/food"
    }
  }, [_c('span', {
    class: {
      'active': _vm.pagename === 'food'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.nav.food)
    }
  })])], 1), _c('br'), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/projects"
    }
  }, [_c('span', {
    class: {
      'active': _vm.pagename === 'projects'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.nav.projects)
    }
  })])], 1), _c('br'), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/takeaway"
    }
  }, [_c('span', {
    class: {
      'active': _vm.pagename === 'takeaway'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.nav.takeaway)
    }
  })])], 1), _c('br'), _vm._v(" "), _c('li', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#gallery'),
      expression: "'#gallery'"
    }],
    on: {
      "click": _vm.clickNavPanel
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.nav.gallery)
    }
  })]), _c('br'), _vm._v(" "), _c('li', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#contact-section'),
      expression: "'#contact-section'"
    }],
    on: {
      "click": _vm.clickNavPanel
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.nav.contact)
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "header-arrow",
    class: {
      'active': !_vm.hideArrow && _vm.pagename !== 'about'
    }
  }, [_c('img', {
    staticClass: "social-icon",
    attrs: {
      "src": 'static/img/common/left_dark.svg'
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a14bc8a4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = 147
// module chunks = 2